import PageHeader from '~/components/common/PageHeader.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  components: {
    PageHeader
  },
  layout: '_base',
  head() {
    return generateMetaHead({
      routePath: this.$route.path
    });
  }
};